import React from 'react'
import StateMedicaidSearchView from './StateMedicaidSearchView'

const StateMedicaidSearch = ({ isQuickSearch = true, applicantId = '' }) => {
    return (
        <div className={`${!isQuickSearch ? 'm-3' : ''}`}>
            <StateMedicaidSearchView isQuickSearch={isQuickSearch} applicantId={applicantId} />
        </div>
    )
}

export default StateMedicaidSearch
